module.exports = __webpack_public_path__ + "img/fire-flame-curved.5894b085.svg";